document.addEventListener('DOMContentLoaded', function() {
    function updateBordersInputs(selector) {
        document.querySelectorAll(selector).forEach(radio => {
            const li = radio.closest('li');
            if (li) {
                if (radio.checked) {
                    li.classList.add('selected-input');
                } else {
                    li.classList.remove('selected-input');
                }
            }
        });
    }

    function observeInputs(selector, container) {
        updateBordersInputs(selector);

        const element = document.querySelector(container);
        if (element) {
            const observer = new MutationObserver(() => updateBordersInputs(selector));
            observer.observe(element, { childList: true, subtree: true });
        }
    }

    // Página Checkout
    observeInputs('.checkout-step.step-2 input[type="radio"]', '.checkout-step.step-2');

    // Página Order Pay
    observeInputs('.woocommerce-order-pay #payment input[type="radio"]', '.woocommerce-order-pay #payment');


	const paymentMethods = document.querySelector('input[name="payment_method"]');

	if(paymentMethods) {
		const removeCheckedAttribute = () => {
			document.querySelectorAll('input[name="payment_method"]:checked').forEach(input => {
					input.checked = false;
			});
		};
	
		jQuery(document.body).on('updated_checkout', () => {

      const paymentStep = document.querySelector('.checkout-step-payment');
      if (paymentStep && paymentStep.classList.contains('show-block')) {
          return; 
      }
      
      removeCheckedAttribute();

      const stripePaymentBoxes = document.querySelectorAll('#payment .payment_box');
      if (stripePaymentBoxes) {
          stripePaymentBoxes.forEach(box => {
              box.style.display = 'none';
          });
      }
		});
	}
});


